export default __webpack_public_path__ + "static/media/intermx.edcf46de.svg";